import api from "@/services/westore/adapters/api_adapter";

class Entity {
  static prefix = "/api";

  static create(uri, data) {
    return api.create(Entity.prefix + uri, data);
  }

  static get(uri, id = null, params = {}) {
    return api.get(Entity.buildEndpoint(uri, id), params);
  }

  static post({ uri, id = null, payload = {} }) {
    return api.post(Entity.buildEndpoint(uri, id), payload);
  }

  static put({ uri, id = null, payload = {} }) {
    return api.put(Entity.buildEndpoint(uri, id), payload);
  }

  static patch({ uri, id = null, payload = {} }) {
    return api.patch(Entity.buildEndpoint(uri, id), payload);
  }
  static delete(uri, id = null, params = {}) {
    return api.delete(Entity.buildEndpoint(uri, id), params);
  }
  static getAll(uri, params) {
    return api.get(this.buildEndpoint(uri), params);
  }

  static hasFiles() {
    api.hasFiles();
    return this;
  }

  static blobResponse() {
    api.blobResponse();
    return this;
  }

  static buildEndpoint(uri, id = null) {
    let endpoint = `${Entity.prefix + uri}`;
    if (id) {
      endpoint += `/${id}`;
    }

    return endpoint;
  }

  static getResponse() {
    return api.getResponse();
  }

  static getHeader(key) {
    return this.getResponse().headers[key] ?? null;
  }
}

export default Entity;
